import { toast } from 'react-toastify';

import { ID } from 'app/components/Table/core/types';

import { ApiResponse, MailStats } from 'app/modules/mail-history/core/types';

import { getResponseError } from 'app/helpers/errors';

import { API_URL } from 'app/constants/environments';

import axios from 'axios';

export const retrieveTrackedMailStats = async (query: string): Promise<{ data: MailStats[] }> => {
  try {
    const response = await axios.get<ApiResponse<MailStats>>(
      `${API_URL}/api/mail-tracking?${query}`,
    );

    if (!response.data.success)
      throw new Error(response.data.message || 'Failed to retrieve tracked mail stats');

    return {
      data: response.data.data as MailStats[],
    };
  } catch (error) {
    getResponseError(error);
    throw error;
  }
};

export const mailTrackingConfirmation = async (id: ID): Promise<void> => {
  try {
    const response = await axios.get<ApiResponse<void>>(
      `${API_URL}/api/mail-tracking/confirm/${id}`,
    );

    if (!response.data.success)
      throw new Error(response.data.message || 'Failed to confirm mail tracking');
  } catch (error) {
    getResponseError(error);
    throw error;
  }
};

export const mailTrackingResend = async (id: ID): Promise<void> => {
  try {
    const response = await axios.post<ApiResponse<void>>(
      `${API_URL}/api/mail-tracking/${id}/resend`,
    );

    if (!response.data.success)
      throw new Error(response.data.message || 'Failed to resend mail tracking');

    toast.success(response.data.message || 'Mail tracking resend successfully');
  } catch (error) {
    getResponseError(error);
    throw error;
  }
};
